var _defs, _g, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTryAgainIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:none;}.a{stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:1.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(2 3.406)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M87.983,83.518v-.931A5.6,5.6,0,0,0,78,79.1m-1.2,2.563V82.6a5.607,5.607,0,0,0,9.975,3.5",
    transform: "translate(-75.4 -77)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M32,213.375,33.375,212l1.438,1.375m11.188,0-1.375,1.375-1.437-1.375",
    transform: "translate(-32 -207.781)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "b",
    width: 18,
    height: 18
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgainIcon);
export default __webpack_public_path__ + "static/media/try-again-icon.9cc6e1ec4d3dd86d450523a4c68183e9.svg";
export { ForwardRef as ReactComponent };